import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class ChatAuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (localStorage.getItem('chatLogin') === '1' && localStorage.getItem('currentUserID')) {
      return true;
    }
    this.router.navigate(['/chatlogin'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
